import * as React from "react";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import { useTheme } from "@mui/material/styles";

export default function SplitButton({ options = [], value, onChange }) {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  const selectedIndex = options.findIndex((o) => o.id === value);

  const selectedOption = options[selectedIndex] ?? options[0];

  const handleMenuItemClick = (index) => {
    const selected = options[index];
    onChange?.(selected.id);
    setOpen(false);
  };

  return (
    <>
      <ButtonGroup
        ref={anchorRef}
        variant="contained"
        sx={(theme) => ({
          borderRadius: 1.5,
          overflow: "hidden",
          border: "1px solid",
          borderColor:
            theme.palette.mode === "dark"
              ? "rgba(255,255,255,0.12)"
              : "rgba(0,0,0,0.15)",

          "& .MuiButtonGroup-grouped": {
            textTransform: "none",
            fontWeight: 500,
            fontSize: 13,
            px: 1.2,
            py: 0.6,
            minHeight: 32,
            borderColor: "transparent",
          },
        })}
      >
        <Button
          onClick={() => console.log(selectedOption)}
          sx={(theme) => ({
            minWidth: 90,
            backgroundColor:
              theme.palette.mode === "dark" ? "#2a2a2a" : "#f5f5f5",
            color: theme.palette.text.primary,
            "&:hover": {
              backgroundColor:
                theme.palette.mode === "dark" ? "#3a3a3a" : "#eaeaea",
            },
          })}
        >
          {selectedOption?.display}
        </Button>

        <Button
          size="small"
          onClick={() => setOpen((p) => !p)}
          sx={(theme) => ({
            minWidth: 34,
            px: 0.8,
            backgroundColor:
              theme.palette.mode === "dark" ? "#3a3a3a" : "#e0e0e0",
            color: theme.palette.text.primary,
            "&:hover": {
              backgroundColor:
                theme.palette.mode === "dark" ? "#4a4a4a" : "#d5d5d5",
            },
          })}
        >
          <ArrowDropDownIcon sx={{ fontSize: 18 }} />
        </Button>
      </ButtonGroup>

      <Popper
        open={open}
        anchorEl={anchorRef.current}
        sx={{ zIndex: 999 }}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom" ? "center top" : "center bottom",
            }}
          >
            <Paper sx={{ width: anchorRef.current?.offsetWidth }}>
              <ClickAwayListener onClickAway={() => setOpen(false)}>
                <MenuList>
                  {options.map((option, index) => (
                    <MenuItem
                      key={option.id}
                      selected={index === selectedIndex}
                      onClick={() => handleMenuItemClick(index)}
                    >
                      {option.display}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
}
